import { createFileRoute } from "@tanstack/react-router";

import { CreateFeedItemPage } from "@pages/feed/create-feed-definition/create-feed-definition";

export const Route = createFileRoute("/create-feed-definition")({
  component: CreateFeedItemPage,
});
